"use client";

import { signOut } from "next-auth/react";

export default function Logout() {
  return (
      <button
          // Call signOut on click. It will clear the session and redirect.
          // The callbackUrl tells NextAuth where to send the user after signing out.
          onClick={() => signOut({ callbackUrl: "/login" })}
          className="fixed z-50 top-4 right-4 text-red hover:bg-red hover:text-white hover:p-2 hover:rounded hover:scale-105 active:scale-95 transition-all duration-300 rounded"
      >
        Log Out
      </button>
  );
}